import axios from "axios";
import router from '../../router';
import slug from 'slug';
import qs from 'qs';
import moment from 'moment';

// initial state
const state = () => ({

        'headers': [],
        'items': []

  })

// getters
const getters = {
    getHeaders(state){
        return state.headers;
    },
    getItems(state){
        return state.items;
    }
}

// actions
const actions = {
    
    getNeededMoney: {
        //root: true,
        handler (context, query){
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: context.rootGetters.getApiUrl + '/financiar/getNeededMoney',
                    params: query,
                    paramsSerializer: function(params) {
                        return qs.stringify(params, {arrayFormat: 'repeat'})
                    },
                    headers: { 
                        Authorization: 'Bearer ' + context.rootGetters.getToken,
                        Accept: '*/*'
                    }
                })
                .then(response => {
                    //let token = response.data.token;
                    //context.commit('setToken', token);
                    //localStorage.setItem('access_token', token);
                    //let data = JSON.parse(response.data);
                    console.log(response.data);
                    let headers = [];
                    let items = [];
                    slug.extend({'%':'percent'});
                    response.data.columnNames.forEach(element => {
                        headers.push({'text':element, 'value': slug(element)});
                    });
                    

                    
                    response.data.columnValues.forEach(element => {
                        let item = {};
                        for (var i = 0; i < headers.length; i++) {
                            if(i != 0){ // remove first column (id)
                                item[headers[i].value] = element[i];
                            }
                        }
                        items.push(item);
                    });
                    headers.shift();// remove first column (id)
                    context.commit('setHeaders', headers);
                    context.commit('setItems', items);
                    console.log(headers);
                    console.log(items);
                    resolve(response);
                })
                .catch(error => {

                    if(error.response.status === 401){
                        //context.dispatch('destroyToken');
                        context.dispatch('destroyToken', null, { root: true })
                            .then(() => {
                                router.push({ name: 'login' });
                            })
                    }
                    reject(error);
                })
            });
        }
    },
    getNeededMoneyAsXls: {
        //root: true,
        handler (context, query){
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: context.rootGetters.getApiUrl + '/financiar/getNeededMoneyAsXls',
                    params: query,
                    paramsSerializer: function(params) {
                        return qs.stringify(params, {arrayFormat: 'repeat'})
                    },
                    headers: { 
                        Authorization: 'Bearer ' + context.rootGetters.getToken,
                        Accept: '*/*'
                    },
                    responseType: 'arraybuffer'
                })
                .then(response => {

                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    let version = moment().format('YYYYMMDDHHmmss');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'RaportNecesarNumerar_'+version+'.xls');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    resolve(response);
                })
                .catch(error => {

                    if(error.response.status === 401){
                        //context.dispatch('destroyToken');
                        context.dispatch('destroyToken', null, { root: true })
                            .then(() => {
                                router.push({ name: 'login' });
                            })
                    }
                    reject(error);
                })
            });
        }
    },
}

// mutations
const mutations = {
    setHeaders(state, headers){
        state.headers = headers;
    },
    setItems(state, items){
        state.items = items;
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}